<template>
  <v-row>
    <v-col cols="12">
      <v-card elevation="2" v-if="activeProgram && !loading">
        <v-card-title>Current Program</v-card-title>
        <v-simple-table>
          <tbody>
            <tr>
              <td><strong>Subscription</strong></td>
              <td>{{ subscription }}</td>
            </tr>
            <!-- <tr>
              <td><strong>Current Program Block (legacy)</strong></td>
              <td>
                <span v-if="activeProgram.program">{{ activeProgram.program.name }}</span>
              </td>
            </tr> -->
            <tr>
              <td><strong>Nutrition Plan</strong></td>
              <td>
                <span v-if="userProfile.coachingNutritionPlan">
                  <a :href="userProfile.coachingNutritionPlan.pdf" class="secondary--text" target="_blank">
                    Serving size: {{ userProfile.coachingNutritionPlan.servingSize }} - Dietary Restriction
                    {{ userProfile.coachingNutritionPlan.dietaryRestriction }}
                  </a>
                </span>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
        <v-card-actions>
          <v-btn
            v-if="activeProgram.program && activeProgram.program.name != 'Onboarding'"
            @click="showUserProgramModal"
            >Manage User Program</v-btn
          >
          <v-btn v-else :to="'/coaching/onboarding/' + userId">Onboarding</v-btn>
        </v-card-actions>
        <v-dialog v-model="modals.userProgram" transition="dialog-bottom-transition">
          <user-program :key="modalCacheBust" :close="closeUserProgramModal" :user-id="userId"></user-program>
        </v-dialog>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { USER_PROGRAMS_QUERY } from "../../../constants/graphql/user_program/user_program";
import { YYYYMMDD_readable } from "../../../lib/fancy_date";
import UserProgram from "../../dashboard/components/UserProgram";

export default {
  name: "ClientUserProgram.vue",
  props: ["userId"],
  components: {
    UserProgram,
  },
  data() {
    return {
      modalCacheBust: 0,
      modals: {
        userProgram: false,
        assessmentModal: false,
      },
      loading: true,
      activeProgram: {},
      subscription: "",
      paidUpUntil: null,
      userProfile: [],
    };
  },
  computed: {
    nextProgramBlock() {
      return this.activeProgram?.nextProgram
        ? this.activeProgram?.nextProgram?.name
        : this.activeProgram?.program?.nextProgramBlock
        ? this.activeProgram?.program?.nextProgramBlock?.name
        : "";
    },
  },
  methods: {
    formatDate(date) {
      return YYYYMMDD_readable(date);
    },
    showUserProgramModal() {
      this.modalCacheBust++;
      this.modals.userProgram = true;
    },
    closeUserProgramModal() {
      this.modals.userProgram = false;
    },
  },
  apollo: {
    userPrograms: {
      query: USER_PROGRAMS_QUERY,
      variables() {
        return {
          userId: this.userId,
        };
      },
      result(response) {
        let activePrograms = response.data.clientUserPrograms.userPrograms.filter(
          (program) => program.disabled === false
        );
        this.subscription = response.data.clientUserPrograms.subscriptionName;
        this.paidUpUntil = response.data.clientUserPrograms.paidUpUntil;

        if (activePrograms.length > 0) this.activeProgram = activePrograms[0];
        this.userProfile = response.data.clientUserPrograms.userProfile;

        this.loading = false;
      },
      update: (data) => data.clientUserPrograms.userPrograms,
    },
  },
};
</script>
